/* eslint-disable react/prop-types */
import { Loader2 } from "lucide-react";
import React from "react";

function Spinner({ inside }) {
  return (
    <div className={inside || "flex h-[100dvh] items-center justify-center"}>
      <Loader2 className="animate-spin" />
    </div>
  );
}

export default Spinner;
